import { ApplicationEnvironment, TargetEnvironment } from './environment.interface';

export const environment: ApplicationEnvironment = {
    targetEnvironment: TargetEnvironment.Default,
    launchDarklyConfig: {
        clientId: '664590c02c638010dc55095f'
    },
    abstractionLayerConfig: {
        stagingUri: 'https://db2guulfzfdl7gbbaqsxuq7fku.appsync-api.eu-north-1.amazonaws.com/graphql',
        releaseUri: 'https://gcjpczafmrcdpjuxuj3yeloujm.appsync-api.eu-north-1.amazonaws.com/graphql'
    },
    authLayerConfig: {
        stagingUri: 'https://fprf6glbwvdxjotfqptkz7zeg4.appsync-api.eu-north-1.amazonaws.com/graphql',
        releaseUri: 'https://7t7hgxyzyzb6hi5fevn2dwl3ce.appsync-api.eu-north-1.amazonaws.com/graphql',
    },
    logConfig: {
        application: 'driving-restrictions',
        env: 'prod',
        graphqlUrl:  'https://heuw5ttbmfbvrjgjcycy4475ri.appsync-api.eu-north-1.amazonaws.com/graphql',
        logLevel: 2,
        console: true,
        debounceTime: 5000,
    },
    colaConfig: {
        redirectUrl: 'https://testtools.scania.com/login'
    },
    environmentName: 'prod',
    flags: {
        staging: 'staging',
    },
    params: {
        oneTimeToken: 'fenixOneTimeToken'
    }

};
